import { RoutingIDs } from '../../../helpers/RoutingIDs';

export function buildChildrenEffizienznetzwerkDokumentenablage(): any[] {
    const parentRouting = {
        ...RoutingIDs.ROUTE_EFFIZIENZNETZWERK_DOKUMENTENABLAGE,
        // terminateOn: RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE,
    }
    return [
        {
            name: 'Netzwerk-Informationen',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 0 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 0 },
        },
        {
            name: 'Dokumente Teilnahme',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 1 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 1 },
        },
        {
            name: 'Betriebsberatung',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 2 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 2 },
        },
        {
            name: 'Veranstaltungen',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 3 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 3 },
        },
        {
            name: 'Monitoring',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 4 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 4 },
        },
        {
            name: 'Sonstiges (Netzwerk)',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 5 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 5 },
        },
        {
            name: 'Verträge',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 6 },
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 6 },
            children: buildChildrenEffizienznetzwerkDokumentenablageVertraege(),
        },
        {
            name: 'Kommunikation',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 7 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 7 },
        },
        {
            name: 'Genehmigungen/Zulassungen',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 8 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 8 },
        },
        {
            name: 'Gebäude',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 9 },
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 9 },
            children: buildChildrenEffizienznetzwerkDokumentenablageGebaeude(),
        },
        {
            name: 'Sonstiges',
            // path: { ...parentRouting, [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 10 }
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 10 },
        },
    ];
}

export function buildChildrenEffizienznetzwerkDokumentenablageVertraege(): any[] {
    const parentRouting = {
        ...RoutingIDs.ROUTE_EFFIZIENZNETZWERK_DOKUMENTENABLAGE,
        // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 6,
        [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 6,
        // terminateOn: RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE,
    }
    return [
        {
            name: 'Strom',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE]: 0
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE]: 0,
            },
        },
        {
            name: 'Wärme',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE]: 1
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE]: 1,
            },
        },
        {
            name: 'Kraftstoffe',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE]: 2
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE]: 2,
            },
        },
        {
            name: 'Sonstige',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE]: 3
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_VERTRAEGE]: 3,
            },
        },
    ];
}

export function buildChildrenEffizienznetzwerkDokumentenablageGebaeude(): any[] {
    const parentRouting = {
        ...RoutingIDs.ROUTE_EFFIZIENZNETZWERK_DOKUMENTENABLAGE,
        // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 9,
        [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE]: 9,
        // terminateOn: RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE,
    }
    return [
        {
            name: 'Planungsunterlagen / Fotos',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 0
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 0,
            },
        },
        {
            name: 'Statistische Berechnungen / Wärmeschutz',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 1
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 1,
            },
        },
        {
            name: 'Sanierungen',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 2
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 2,
            },
        },
        {
            name: 'Zusätzliche Berechnungen / Konzepte',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 3
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 3,
            },
        },
        {
            name: 'Sonstiges (Gebäude)',
            path: {
                ...parentRouting,
                // [RoutingIDs.TABS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 4
                [RoutingIDs.TABS_ZUSATZTOOLS_EFFIZIENZNETZWERK_DOKUMENTENABLAGE_GEBAEUDE]: 4,
            },
        },
    ];
}

export function buildChildrenZusatztoolsDokumentenablage(): any[] {
    const parentRouting = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_DOKUMENTENABLAGE,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE
    }
    return [
        {
            name: 'Netzwerk-Informationen',
            disabled: true
        },
        {
            name: 'Dokumente Teilnahme',
            disabled: true
        },
        {
            name: 'Betriebsberatung',
            disabled: true
        },
        {
            name: 'Veranstaltungen',
            disabled: true
        },
        {
            name: 'Monitoring',
            disabled: true
        },
        {
            name: 'Sonstiges (Netzwerk)',
            disabled: true
        },
        {
            name: 'Verträge',
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE]: 6 },
            children: buildChildrenZusatztoolsDokumentenablageVertraege()
        },
        {
            name: 'Kommunikation',
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE]: 7 }
        },
        {
            name: 'Genehmigungen/Zulassungen',
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE]: 8 }
        },
        {
            name: 'Gebäude',
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE]: 9 },
            children: buildChildrenZusatztoolsDokumentenablageGebaeude()
        },
        {
            name: 'Sonstiges',
            path: { ...parentRouting, [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE]: 10 }
        }
    ];
}

export function buildChildrenZusatztoolsDokumentenablageVertraege(): any[] {
    const parentRouting = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_DOKUMENTENABLAGE,
        [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE]: 6,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_VERTRAEGE
    }
    return [
        {
            name: 'Strom',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_VERTRAEGE]: 0
            }
        },
        {
            name: 'Wärme',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_VERTRAEGE]: 1
            }
        },
        {
            name: 'Kraftstoffe',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_VERTRAEGE]: 2
            }
        },
        {
            name: 'Sonstige',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_VERTRAEGE]: 3
            }
        }
    ];
}

export function buildChildrenZusatztoolsDokumentenablageGebaeude(): any[] {
    const parentRouting = {
        ...RoutingIDs.ROUTE_ZUSATZTOOLS_DOKUMENTENABLAGE,
        [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE]: 9,
        terminateOn: RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE
    }
    return [
        {
            name: 'Planungsunterlagen / Fotos',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE]: 0
            }
        },
        {
            name: 'Statistische Berechnungen / Wärmeschutz',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE]: 1
            }
        },
        {
            name: 'Sanierungen',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE]: 2
            }
        },
        {
            name: 'Zusätzliche Berechnungen / Konzepte',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE]: 3
            }
        },
        {
            name: 'Sonstiges (Gebäude)',
            path: {
                ...parentRouting,
                [RoutingIDs.TABS_ZUSATZTOOLS_DOKUMENTENABLAGE_GEBAEUDE]: 4
            }
        }
    ];
}
